<template>

    <div class="grid grid-cols-10 gap-2 mt-3">


        <div :class="{'text-gray-300':!activeLocal}" class="col-span-9 font-medium">
            <a :href="link" v-if="activeLocal">{{ title }}</a>
            <span v-else>{{ title }}</span>
        </div>

        <div>
            <t-toggle v-model="activeLocal" :readonly="axios" @input="toggle"/>
        </div>

        <template v-if="activeLocal">

            <div v-if="comment" class="col-span-full col-start-1 text-xs text-grey-500">
                {{ comment }}
            </div>

            <!--    <div class="col-start-2 col-end-5"></div>-->
            <div class="col-span-full">
                <div v-if="editing" class="flex items-center space-x-3">


                    <t-input v-model="form.price" class="w-1/4" placeholder="Цена"/>
                    <span v-if="type==='rent'">₽</span>
                    <t-select
                        v-model="form.priceUnit"
                        :options=priceUnits
                        class="w-1/4" />

                  <button type="button"
                          class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          @click="save">
                    Сохранить
                  </button>

                    <button class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="button"
                            @click="cancel">
                        Отменить
                    </button>

                </div>

                <div v-else class="flex items-center space-x-3">

                    <span  v-if="state.price"
                            class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium "
                           :class="type==='rent' ? 'bg-red-100 text-red-800':'bg-blue-100 text-blue-800'"
                    >
                            {{ parseInt(state.price).toLocaleString() }} {{ type==='rent'?'₽ /':'' }}{{ priceUnits[state.priceUnit.toString()] }}
                    </span>
                    <span v-else
                        class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium"
                        :class="type==='rent' ? 'bg-red-100 text-red-800':'bg-blue-100 text-blue-800'"
                    >
                        Цена по договоренности
                    </span>

                    <button class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="button"
                            @click="editing = true">
                        Изменить
                    </button>

                    <a  v-if="duplicate"
                        class="inline-flex items-center px-2.5 py-0.5 text-xs border font-medium leading-none
                            text-gray-700 bg-white border-gray-300 shadow-sm rounded hover:bg-indigo-300 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        role="button"
                        title="Дублировать в другом городе"
                        :href="route('machinery-payloads.duplicate', payloadId)">

                        <!-- bg-indigo-500 -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                        </svg>
                        Дублировать
                    </a>

                </div>


            </div>

        </template>

    </div>

</template>

<script>
import MyTransition from "../elements/MyTransition";

export default {
    name: "PayloadItem",
    components: {MyTransition},
    props: {
        type: {
            type: String,
            default: 'rent',
            validator: (val) => ['rent', 'sale'].includes(val)
        },
        payloadId: {
            type: Number,
            required: true
        },
        active: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            required: true
        },
        link: {
          type: String,
          required: true
        },
        duplicate: {
          type: Boolean,
          required: false,
          default: false
        },
        comment: String,
        price: {
            type: Number,
            default: 0
        },
        priceUnit: {
            type: Number,
            default: 1
        },
        priceUnits: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            activeLocal: this.active,
            editing: false,
            axios: false,
            state: {
                price: this.price,
                priceUnit: this.priceUnit.toString(),
            },
            form: {
                price: this.price,
                priceUnit: this.priceUnit.toString(),
            }

        }
    },
    methods: {
        toggle(state) {
            this.axios = true;
            axios.get(this.route('api.payload.toggle',this.payloadId)).then ( responce => {
                this.axios=false;
                this.activeLocal = state;
                if (this.type === 'rent'){
                   this.$root.$emit('count-of-rent-payloads-changed',state);
                   return;
                }
                this.$root.$emit('count-of-sale-payloads-changed',state);

            })

        },
        cancel() {
            this.editing = false;
            this.form = this.state;
        },

        save() {
            axios.put(this.route('api.payload.update-price', this.payloadId), this.form).then (response => {
                this.state = this.form;
                this.editing = false;
            });

        }

    },
}
</script>

<style scoped>

</style>
